import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'gatsby-plugin-intl';

import Carousel from '../Carousel/Carousel';
import ClassCard from '../ClassCard/ClassCardFlip';
import Container from '../../layout/Container';
import SectionTitle from '../SectionTitle/SectionTitle';
import { translateLocal } from '../../../i18n';

import './ComingSoon.scss';

const ComingSoon = ({
  items, pageData, transparent,
}) => {
  const intl = useIntl();
  const lang = intl.locale;

  const data = {
    items: items.sort((a, b) => a.order - b.order),
  };

  return (
    <div className={`coming-soon ${transparent ? 'transparent' : ''}`} id="coming-soon">
      <Container className="intro">
        {!!pageData.title && !!translateLocal(pageData.title) && (
          <SectionTitle
            title={translateLocal(pageData.title)}
            subtitle={translateLocal(pageData.subtitle)}
          />
        )}

        <div className="carousel">
          <Carousel
            autoPlay
            // onSlideChange={onSlideChange}
          >
            {data?.items?.map((item, index) => (
              <ClassCard
                key={index}
                image={{ src: item.teaserImage.childImageSharp.fluid, alt: translateLocal(item.image.alt, lang) }}
                name={item.name}
                domain={translateLocal(item.domain, lang)}
                animated={false}
                small
                preSale={item.preSale}
                preSaleLabel={item.preSaleLabel}
                centered
              />
            ))}
          </Carousel>
        </div>
      </Container>
    </div>
  );
};

ComingSoon.propTypes = {
  items: PropTypes.array.isRequired,
  pageData: PropTypes.object.isRequired,
  transparent: PropTypes.bool,
};

ComingSoon.defaultProps = {
  transparent: false,
};

export default ComingSoon;
